import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof _Symbol && _getIteratorMethod(r) || r["@@iterator"]; if (!t) { if (_Array$isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { var _context; if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = _sliceInstanceProperty(_context = {}.toString.call(r)).call(_context, 8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _Set from "@babel/runtime-corejs3/core-js-stable/set";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _parseFloat from "@babel/runtime-corejs3/core-js-stable/parse-float";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import { LeaseTypeEnum, ListingSourceEnum, ListingStateEnum } from "./Enums";
/**
 * `leaseType` values a coworking-only field (desk count, desk rate) gates on. Shared so the
 * transaction listings table's display gate and edit gate can't drift apart.
 */
var COWORKING_LEASE_TYPES = [LeaseTypeEnum.COWORKING.value, LeaseTypeEnum.ENTERPRISE_COWORKING.value];
export function isCoworkingLeaseType(leaseType) {
  return _includesInstanceProperty(COWORKING_LEASE_TYPES).call(COWORKING_LEASE_TYPES, leaseType !== null && leaseType !== void 0 ? leaseType : "");
}
/**
 * `ListingSourceEnum` values that must never be offered as a user-selectable source.
 * Consumed by both the legacy MUI source fields and the Alize `ListingSourceDialog`, so it
 * lives here rather than inside either stack's component (see `docs/alize-migration.md` §1).
 */
export var SOURCE_EXCLUDED_VALUES = [ListingSourceEnum.PRIORITY_QUEUE.value,
// kept in DB for historical tracking

// values listed as strings to avoid reference exceptions when they are deleted from the enum.
"build_out", "jas_log", "building_clean_up", "broker_outreach"];
export var VALID_LISTING_STATES = [ListingStateEnum.PREDICTED, ListingStateEnum.ON_MARKET, ListingStateEnum.LEASED, ListingStateEnum.NOT_AVAILABLE];

/** Still stored on listings, but no longer a product-facing status. */
export var HIDDEN_LISTING_STATE_VALUES = [ListingStateEnum.IN_PROPOSALS.value, ListingStateEnum.IN_LEASES.value, ListingStateEnum.DEAD.value];

/**
 * Consolidates listing states according to business rules:
 * - IN_PROPOSALS, IN_LEASES, and ON_MARKET all show as "On Market"
 * - NOT_AVAILABLE and DEAD both show as "Not Available"
 * - All other states return their original labels
 *
 * @param listingState - The original listing state value
 * @returns Valid listing state with value, label, and originalValue
 */
export var getValidListingStateLabels = function getValidListingStateLabels(listingState) {
  if (!listingState) {
    return null;
  }
  var originalStateObj = _valuesInstanceProperty(ListingStateEnum)[listingState];
  if (!originalStateObj) {
    return null;
  }

  // Consolidation rules
  switch (listingState) {
    case ListingStateEnum.IN_PROPOSALS.value:
    case ListingStateEnum.IN_LEASES.value:
    case ListingStateEnum.ON_MARKET.value:
      return {
        value: ListingStateEnum.ON_MARKET.value,
        label: ListingStateEnum.ON_MARKET.label,
        originalValue: listingState
      };
    case ListingStateEnum.NOT_AVAILABLE.value:
    case ListingStateEnum.DEAD.value:
      return {
        value: ListingStateEnum.NOT_AVAILABLE.value,
        label: ListingStateEnum.NOT_AVAILABLE.label,
        originalValue: listingState
      };
    default:
      // All other states (predicted, leased) return themselves
      return {
        value: originalStateObj.value,
        label: originalStateObj.label,
        originalValue: listingState
      };
  }
};

/**
 * Expands a product-facing status selection into the DB values a `listing_state__in` filter
 * must send. On Market still includes In Proposals / In Leases rows; Not Available still
 * includes Pulled From Market (`dead`) rows.
 */
export function expandListingStatesForQuery(states) {
  var expanded = new _Set(states);
  if (expanded.has(ListingStateEnum.ON_MARKET.value)) {
    expanded.add(ListingStateEnum.IN_PROPOSALS.value);
    expanded.add(ListingStateEnum.IN_LEASES.value);
  }
  if (expanded.has(ListingStateEnum.NOT_AVAILABLE.value)) {
    expanded.add(ListingStateEnum.DEAD.value);
  }
  return _Array$from(expanded);
}

/** Collapses stored listing states back to the product-facing set for filter chips / editors. */
export function collapseListingStatesForDisplay(states) {
  var seen = new _Set();
  var collapsed = [];
  var _iterator = _createForOfIteratorHelper(states),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var state = _step.value;
      var valid = getValidListingStateLabels(state);
      if (!valid || seen.has(valid.value)) continue;
      seen.add(valid.value);
      collapsed.push(valid.value);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return collapsed;
}

/**
 * Returns null for null/undefined/empty values, and 0 for zero values.
 * Otherwise returns the parsed number without altering its precision.
 *
 * Important for values that round-trip through edit mode (e.g. asking_rate,
 * where storage keeps 10 decimal places and a 2-decimal truncation silently
 * corrupts mixed-rate listings — see RKG-7554).
 */
export var preserveDecimalIfNotNull = function preserveDecimalIfNotNull(value) {
  if (value === 0) {
    return 0;
  }
  if (value === null || value === undefined || value === "") {
    return null;
  }
  var numValue = typeof value === "number" ? value : _parseFloat(value);
  if (isNaN(numValue)) {
    return null;
  }
  return numValue;
};